// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/users.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/images/activeUsers.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/images/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/images/activeUser.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listing-page-wrapper {
  width: 80%;
}
.cards-listing-wrapper {
  padding: 0 20px;
}
.card-icon-container {
  width: 50px;
  justify-content: right;
}
.icon-dollar {
  font-size: 15px;
}
.listing-search-wrapper {
  padding: 0 20px;
}
.case-search {
  box-shadow: 0px 3px 10px #0000000b;
  -ms-box-shadow: 0px 3px 10px #0000000b;
  -webkit-box-shadow: 0px 3px 10px #0000000b;
  -moz-box-shadow: 0px 3px 10px #0000000b;
  border-radius: 6px;
  background: #fff;
  border: none;
  width: 100%;
  height: 40px;
  line-height: 40px;
  outline: none;
  font-size: 14px;
  padding: 0 20px;
}
.listing-search-bar {
  width: calc(100% - 185px);
}
.list-sort-button {
  font-size: 16px;
  cursor: pointer;
  line-height: 40px;
  height: 40px;
  color: #1984bc;
  font-weight: 500;
  background: #fff;
  display: inline-block;
  box-shadow: 0px 3px 10px #0000000a;
  -ms-box-shadow: 0px 3px 10px #0000000a;
  -webkit-box-shadow: 0px 3px 10px #0000000a;
  -moz-box-shadow: 0px 3px 10px #0000000a;
  border-radius: 6px;
  padding: 0 20px;
}
.list-sortIcon {
  margin-left: 10px;
}
.side-nav-sort li {
  height: 48px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  margin: 7px 14px;
  justify-content: space-between;
  cursor: pointer;
}
.side-nav-sort li:hover {
  background-color: #f1f4f6;
}
.side-nav-sort li span {
  font-size: 14px;
  margin: 0 14px;
}
.bold-sort-text {
  font-size: 14px;
  margin: 0 14px;
  font-weight: 600;
}
.search-heading {
  margin-left: 14px;
}

.date-width {
  margin: 0 24px;
  margin-top: 10px;
}
.list-search-button {
  font-size: 16px;
  cursor: pointer;
  line-height: 40px;
  height: 40px;
  color: white;
  font-weight: 500;
  background: #1984bc;
  display: inline-block;
  box-shadow: 0px 3px 10px #0000000a;
  -ms-box-shadow: 0px 3px 10px #0000000a;
  -webkit-box-shadow: 0px 3px 10px #0000000a;
  -moz-box-shadow: 0px 3px 10px #0000000a;
  border-radius: 6px;
  padding: 0 20px;
}
.listing-search-button-continer {
  display: flex;
  justify-content: center;
}
.top-margin {
  margin-top: 7px;
}
.line-separation-width {
  margin-right: 20px;
}

.sort-side-nav.active {
  color: green;
}
.active {
  color: #1984bc;
  background-color: #0177b519;
}
.search-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 40px;
  background: #fff;
  box-shadow: 0px 3px 10px #0000000a;
  -ms-box-shadow: 0px 3px 10px #0000000a;
  -webkit-box-shadow: 0px 3px 10px #0000000a;
  -moz-box-shadow: 0px 3px 10px #0000000a;
  border-radius: 6px;
}
.searchIcon {
  width: 18px;
}
.cases-container {
  padding: 0 20px;
  margin-bottom: 20px;
  display: flex;
}
.case-text {
  height: 40px;
  background: #fff;
  box-shadow: 0px 3px 10px #0000000a;
  -ms-box-shadow: 0px 3px 10px #0000000a;
  -webkit-box-shadow: 0px 3px 10px #0000000a;
  -moz-box-shadow: 0px 3px 10px #0000000a;
  width: 145px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.case-text p {
  font-size: 12px;
  font-weight: 600;
}
.caseActive {
  background-color: #1984bc;
  color: #ffffff;
}
.myCase-container {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.allCase-container {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.all-case-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 12px;
  height: 12px;
  background-size: contain;
  margin-right: 5px;
  background-repeat: no-repeat;
}
.active-all-case-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  width: 12px;
  height: 12px;
  background-size: contain;
  margin-right: 5px;
  background-repeat: no-repeat;
}

.my-case-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 12px;
  height: 12px;
  background-size: contain;
  margin-right: 5px;
  background-repeat: no-repeat;
}
.active-my-case-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  width: 12px;
  height: 12px;
  background-size: contain;
  margin-right: 5px;
  background-repeat: no-repeat;
}
.no-data-container {
  display: flex;
  justify-content: center;
  margin-top: 10%;
}
.no-data-text {
  font-size: 14px;
}
.side-nav-sort li .arrow-size {
  font-size: 19px;
  cursor: pointer;
}
.case-listing-button-container {
  padding: 0 20px;
  margin-top: 12px;
}
.case-listing-button {
  font-size: 14px;
  width: 100%;
  margin-bottom: 8px;
  display: block;
  background: #1984bc;
  color: #fff;
  border: 1px solid #1984bc;
  padding: 10px 25px;
  cursor: pointer;
  line-height: 1.2;
  font-weight: 600;
  -webkit-appearance: none;
  border-radius: 4px;
  transition: all 0.4s;
  -ms-transition: all 0.4s;
  -webkit-transition: all 0.4s;
}
.case-listing-button.applicationAvailable-btn {
  background: transparent;
  color: #1984bc;
}
.side_nav_accordion__wrapper,
.side_nav_accordion__innerWrapper {
  width: 100%;
}
.side_nav_accordion__header {
  margin: 0 20px;
  padding: 20px 20px 15px;
  border: 1px solid #d6d6d6;
  border-radius: 6px;
  display: flex;
  -webkit-display: flex;
  justify-content: space-between;
  background: #fff;
  position: relative;
  align-items: center;
}
.open-outer-accordion .side_nav_accordion__header {
  border: 1px solid #1984bc;
}
.side_nav_accordion__sub_header {
  font-size: 12px;
  font-weight: 400;
  color: red;
}
.side_nav_accordion__wrapper {
  margin-bottom: 10px;
}
.side_nav_accordion__content {
  display: none;
  padding: 10px 10px 10px;
  transition: height 0.4s ease;
}
.open-outer-accordion .side_nav_accordion__content {
  display: block;
}
.side_nav_accordion__header .side_nav_accordionClickField {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  left: 0;
  top: 0;
  cursor: pointer;
}
.side_nav_accordion__accordionHeading {
  font-size: 16px;
  color: #222222;
  font-weight: 700;
  margin-bottom: 0px;
  line-height: 1.3;
  padding-left: 15px;
}
.open-outer-accordion .side_nav_accordion__accordionHeading {
  color: #1984bc;
}
.side_nav_accordion__header .side_nav_icon-delete {
  position: relative;
  z-index: 1;
  top: -2px;
}
.side_nav_heading-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.side_nav_accordion__content_inner {
  height: 0;
  overflow: hidden;
  padding: 5px 10px 0 10px;
  transition: height 0.4s ease;
}
.open-inner-accordion .side_nav_accordion__content_inner {
  height: auto;
  display: flex;
  flex-direction: column;
  margin-left: 30px;
}
.side_nav_accordion__content_inner_label {
  padding-left: 5px;
  font-size: 14px;
  font-weight: 600;
}
.side_nav_accordion__header {
  margin: 0 20px;
  padding: 20px 20px 15px;
  border: 1px solid #d6d6d6;
  border-radius: 6px;
  display: flex;
  -webkit-display: flex;
  justify-content: space-between;
  background: #fff;
  position: relative;
  align-items: center;
}
.side_nav_accordion__header_inner {
  margin: 5px 20px 8px;
  display: flex;
  -webkit-display: flex;
  justify-content: space-between;
  background: #fff;
  position: relative;
  align-items: center;
}
.side_nav_accordion__header_inner .side_nav_accordionClickField_inner {
  /* position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  left: 0;
  top: 0; */
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  width: 100%;
}
.side_nav_accordion__header_inner .side_nav_accordionClickField_inner input,
.accordion--users__wrapper input {
  cursor: pointer;
}
.accordion--users__wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.side_nav_accordion__header_inner .side_nav_accordionClickField_inner > input {
  margin: 0;
}
.side_nav_accordion__accordionHeading_inner {
  color: #505050;
  font-size: 14px;
  font-weight: 600;
}
.side_nav_sub_heading_inner {
  display: flex;
  align-items: center;
}
.side_nav_heading-container_inner {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.side_nav_accordion__content_inner_label {
  display: flex;
  align-items: center;
}
.side_nav_accordion__content_inner_label > label {
  margin-left: 5px;
}
.side_nav_accordion__content_inner_container {
  margin-right: 30px;
  padding: 8px 0;
}
.side_nav_accordion__header_label {
  margin-bottom: 0s;
}
.side_nav_accordion_label {
  font-size: 14px;
  font-weight: 600;
  margin-left: 8px;
  display: inline-block;
}
.open-outer-accordion .side_nav_accordion_outerLabel {
  color: #1984bc;
}
.open-color {
  color: #1984bc;
}
.open-border {
  border: 1px solid #1984bc;
}
.side_nav_inner_value {
  display: flex;
}
.side_nav_inner_value .accArrowIcon {
  margin-left: 8px;
}
.side_nav_accordion__wrapper .accArrowIcon {
  border-bottom: 2px solid #817c7c;
  border-left: 2px solid #817c7c;
  height: 9px;
  width: 9px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  transition: all 0.4s;
  -ms-transition: all 0.4s;
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
}
.side_nav_accordion__wrapper.open-outer-accordion .accArrowIcon-outer,
.side_nav_accordion__wrapper .open-inner-accordion .accArrowIcon-inner {
  border-bottom: 2px solid #1984bc;
  border-left: 2px solid #1984bc;
  transform: rotate(-225deg);
  -ms-transform: rotate(-225deg);
  -webkit-transform: rotate(-225deg);
  -moz-transform: rotate(-225deg);
  margin-top: 2px;
}
.accordion-disable .accArrowIcon-outer,
.accordion-disable .accArrowIcon-inner {
  display: none;
}
.accordion-disable .side_nav_accordion__header {
  cursor: not-allowed;
  background: rgba(214, 214, 212, 0.3);
}
.accordion-disable .side_nav_accordion__header_inner {
  cursor: not-allowed;
}
.accordion-disable .side_nav_accordionClickField,
.accordion-disable .side_nav_accordionClickField_inner {
  pointer-events: none;
}
.produtType-container {
  padding: 20px;
  display: flex;
  display: -webkit-flex;
}
.productTypeField {
  margin-right: 10px;
}
.productTypeValue {
  font-size: 14px;
  position: relative;
  padding-left: 25px;
  cursor: pointer;
}
.productTypeValue:before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  border: 1px solid #000;
  background: #fff;
  left: 0;
  top: 0;
}
.productActive .productTypeValue:before {
  border-color: #1984bc;
}
.productTypeValue:after {
  content: "";
  position: absolute;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: #fff;
  left: 3px;
  top: 3px;
}
.productActive .productTypeValue:after {
  background: #1984bc;
}
.caselisting__table thead tr {
  border-bottom: 1px solid rgb(231 231 228);
  border-radius: 10px;
}
.caselisting__table th {
  vertical-align: middle;
  padding: 15px;
}
.caselisting__table {
  width: 100%;
  text-align: left;
  box-shadow: 0px 3px 20px #0000000a;
  border-radius: 10px;
  background: #fff;
  margin-bottom: 20px;
}
.caselisting__tableHeading {
  font-size: 12px;
  line-height: 1.2;
  color: #989eac;
  font-weight: 500;
}
.caselisting__table tbody tr:nth-child(odd) {
  background: #f8f9fa;
}
.caselisting__table tbody td {
  vertical-align: middle;
  padding: 15px;
}
.caselisting__table tbody td span {
  color: #222222;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 500;
}
.caselisting__rowInfo {
  cursor: pointer;
}
.caselisting__loaderWrapper {
  height: calc(100% - 160px);
  padding: 0 20px;
}
.caselisting__loaderOverlay {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.caselisting__loaderWrapper .loader > div {
  border: 8px solid #1984bc;
  border-color: #1984bc transparent transparent transparent;
}
.caselisting__table tbody td span.caseListing__insuredName {
  color: #1984bc;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/caseListing/CaseListing.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,0CAA0C;EAC1C,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;EAClC,sCAAsC;EACtC,0CAA0C;EAC1C,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;EAClC,sCAAsC;EACtC,0CAA0C;EAC1C,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,sCAAsC;EACtC,0CAA0C;EAC1C,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,sCAAsC;EACtC,0CAA0C;EAC1C,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,yDAAyD;EACzD,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,yDAA+D;EAC/D,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,yDAAwD;EACxD,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,yDAA8D;EAC9D,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;;EAEE,WAAW;AACb;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,OAAO;EACP,MAAM;EACN,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;;;;;WAKS;EACT,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,6BAA6B;EAC7B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;EACP,MAAM;AACR;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,yDAAyD;AAC3D;AACA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".listing-page-wrapper {\n  width: 80%;\n}\n.cards-listing-wrapper {\n  padding: 0 20px;\n}\n.card-icon-container {\n  width: 50px;\n  justify-content: right;\n}\n.icon-dollar {\n  font-size: 15px;\n}\n.listing-search-wrapper {\n  padding: 0 20px;\n}\n.case-search {\n  box-shadow: 0px 3px 10px #0000000b;\n  -ms-box-shadow: 0px 3px 10px #0000000b;\n  -webkit-box-shadow: 0px 3px 10px #0000000b;\n  -moz-box-shadow: 0px 3px 10px #0000000b;\n  border-radius: 6px;\n  background: #fff;\n  border: none;\n  width: 100%;\n  height: 40px;\n  line-height: 40px;\n  outline: none;\n  font-size: 14px;\n  padding: 0 20px;\n}\n.listing-search-bar {\n  width: calc(100% - 185px);\n}\n.list-sort-button {\n  font-size: 16px;\n  cursor: pointer;\n  line-height: 40px;\n  height: 40px;\n  color: #1984bc;\n  font-weight: 500;\n  background: #fff;\n  display: inline-block;\n  box-shadow: 0px 3px 10px #0000000a;\n  -ms-box-shadow: 0px 3px 10px #0000000a;\n  -webkit-box-shadow: 0px 3px 10px #0000000a;\n  -moz-box-shadow: 0px 3px 10px #0000000a;\n  border-radius: 6px;\n  padding: 0 20px;\n}\n.list-sortIcon {\n  margin-left: 10px;\n}\n.side-nav-sort li {\n  height: 48px;\n  display: flex;\n  align-items: center;\n  border-radius: 6px;\n  margin: 7px 14px;\n  justify-content: space-between;\n  cursor: pointer;\n}\n.side-nav-sort li:hover {\n  background-color: #f1f4f6;\n}\n.side-nav-sort li span {\n  font-size: 14px;\n  margin: 0 14px;\n}\n.bold-sort-text {\n  font-size: 14px;\n  margin: 0 14px;\n  font-weight: 600;\n}\n.search-heading {\n  margin-left: 14px;\n}\n\n.date-width {\n  margin: 0 24px;\n  margin-top: 10px;\n}\n.list-search-button {\n  font-size: 16px;\n  cursor: pointer;\n  line-height: 40px;\n  height: 40px;\n  color: white;\n  font-weight: 500;\n  background: #1984bc;\n  display: inline-block;\n  box-shadow: 0px 3px 10px #0000000a;\n  -ms-box-shadow: 0px 3px 10px #0000000a;\n  -webkit-box-shadow: 0px 3px 10px #0000000a;\n  -moz-box-shadow: 0px 3px 10px #0000000a;\n  border-radius: 6px;\n  padding: 0 20px;\n}\n.listing-search-button-continer {\n  display: flex;\n  justify-content: center;\n}\n.top-margin {\n  margin-top: 7px;\n}\n.line-separation-width {\n  margin-right: 20px;\n}\n\n.sort-side-nav.active {\n  color: green;\n}\n.active {\n  color: #1984bc;\n  background-color: #0177b519;\n}\n.search-btn-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  width: 40px;\n  background: #fff;\n  box-shadow: 0px 3px 10px #0000000a;\n  -ms-box-shadow: 0px 3px 10px #0000000a;\n  -webkit-box-shadow: 0px 3px 10px #0000000a;\n  -moz-box-shadow: 0px 3px 10px #0000000a;\n  border-radius: 6px;\n}\n.searchIcon {\n  width: 18px;\n}\n.cases-container {\n  padding: 0 20px;\n  margin-bottom: 20px;\n  display: flex;\n}\n.case-text {\n  height: 40px;\n  background: #fff;\n  box-shadow: 0px 3px 10px #0000000a;\n  -ms-box-shadow: 0px 3px 10px #0000000a;\n  -webkit-box-shadow: 0px 3px 10px #0000000a;\n  -moz-box-shadow: 0px 3px 10px #0000000a;\n  width: 145px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.case-text p {\n  font-size: 12px;\n  font-weight: 600;\n}\n.caseActive {\n  background-color: #1984bc;\n  color: #ffffff;\n}\n.myCase-container {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.allCase-container {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.all-case-icon {\n  background-image: url(\"../../../assets/images/users.svg\");\n  width: 12px;\n  height: 12px;\n  background-size: contain;\n  margin-right: 5px;\n  background-repeat: no-repeat;\n}\n.active-all-case-icon {\n  background-image: url(\"../../../assets/images/activeUsers.svg\");\n  width: 12px;\n  height: 12px;\n  background-size: contain;\n  margin-right: 5px;\n  background-repeat: no-repeat;\n}\n\n.my-case-icon {\n  background-image: url(\"../../../assets/images/user.svg\");\n  width: 12px;\n  height: 12px;\n  background-size: contain;\n  margin-right: 5px;\n  background-repeat: no-repeat;\n}\n.active-my-case-icon {\n  background-image: url(\"../../../assets/images/activeUser.svg\");\n  width: 12px;\n  height: 12px;\n  background-size: contain;\n  margin-right: 5px;\n  background-repeat: no-repeat;\n}\n.no-data-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 10%;\n}\n.no-data-text {\n  font-size: 14px;\n}\n.side-nav-sort li .arrow-size {\n  font-size: 19px;\n  cursor: pointer;\n}\n.case-listing-button-container {\n  padding: 0 20px;\n  margin-top: 12px;\n}\n.case-listing-button {\n  font-size: 14px;\n  width: 100%;\n  margin-bottom: 8px;\n  display: block;\n  background: #1984bc;\n  color: #fff;\n  border: 1px solid #1984bc;\n  padding: 10px 25px;\n  cursor: pointer;\n  line-height: 1.2;\n  font-weight: 600;\n  -webkit-appearance: none;\n  border-radius: 4px;\n  transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  -webkit-transition: all 0.4s;\n}\n.case-listing-button.applicationAvailable-btn {\n  background: transparent;\n  color: #1984bc;\n}\n.side_nav_accordion__wrapper,\n.side_nav_accordion__innerWrapper {\n  width: 100%;\n}\n.side_nav_accordion__header {\n  margin: 0 20px;\n  padding: 20px 20px 15px;\n  border: 1px solid #d6d6d6;\n  border-radius: 6px;\n  display: flex;\n  -webkit-display: flex;\n  justify-content: space-between;\n  background: #fff;\n  position: relative;\n  align-items: center;\n}\n.open-outer-accordion .side_nav_accordion__header {\n  border: 1px solid #1984bc;\n}\n.side_nav_accordion__sub_header {\n  font-size: 12px;\n  font-weight: 400;\n  color: red;\n}\n.side_nav_accordion__wrapper {\n  margin-bottom: 10px;\n}\n.side_nav_accordion__content {\n  display: none;\n  padding: 10px 10px 10px;\n  transition: height 0.4s ease;\n}\n.open-outer-accordion .side_nav_accordion__content {\n  display: block;\n}\n.side_nav_accordion__header .side_nav_accordionClickField {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  cursor: pointer;\n}\n.side_nav_accordion__accordionHeading {\n  font-size: 16px;\n  color: #222222;\n  font-weight: 700;\n  margin-bottom: 0px;\n  line-height: 1.3;\n  padding-left: 15px;\n}\n.open-outer-accordion .side_nav_accordion__accordionHeading {\n  color: #1984bc;\n}\n.side_nav_accordion__header .side_nav_icon-delete {\n  position: relative;\n  z-index: 1;\n  top: -2px;\n}\n.side_nav_heading-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.side_nav_accordion__content_inner {\n  height: 0;\n  overflow: hidden;\n  padding: 5px 10px 0 10px;\n  transition: height 0.4s ease;\n}\n.open-inner-accordion .side_nav_accordion__content_inner {\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  margin-left: 30px;\n}\n.side_nav_accordion__content_inner_label {\n  padding-left: 5px;\n  font-size: 14px;\n  font-weight: 600;\n}\n.side_nav_accordion__header {\n  margin: 0 20px;\n  padding: 20px 20px 15px;\n  border: 1px solid #d6d6d6;\n  border-radius: 6px;\n  display: flex;\n  -webkit-display: flex;\n  justify-content: space-between;\n  background: #fff;\n  position: relative;\n  align-items: center;\n}\n.side_nav_accordion__header_inner {\n  margin: 5px 20px 8px;\n  display: flex;\n  -webkit-display: flex;\n  justify-content: space-between;\n  background: #fff;\n  position: relative;\n  align-items: center;\n}\n.side_nav_accordion__header_inner .side_nav_accordionClickField_inner {\n  /* position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  left: 0;\n  top: 0; */\n  cursor: pointer;\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n}\n.side_nav_accordion__header_inner .side_nav_accordionClickField_inner input,\n.accordion--users__wrapper input {\n  cursor: pointer;\n}\n.accordion--users__wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n}\n.side_nav_accordion__header_inner .side_nav_accordionClickField_inner > input {\n  margin: 0;\n}\n.side_nav_accordion__accordionHeading_inner {\n  color: #505050;\n  font-size: 14px;\n  font-weight: 600;\n}\n.side_nav_sub_heading_inner {\n  display: flex;\n  align-items: center;\n}\n.side_nav_heading-container_inner {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.side_nav_accordion__content_inner_label {\n  display: flex;\n  align-items: center;\n}\n.side_nav_accordion__content_inner_label > label {\n  margin-left: 5px;\n}\n.side_nav_accordion__content_inner_container {\n  margin-right: 30px;\n  padding: 8px 0;\n}\n.side_nav_accordion__header_label {\n  margin-bottom: 0s;\n}\n.side_nav_accordion_label {\n  font-size: 14px;\n  font-weight: 600;\n  margin-left: 8px;\n  display: inline-block;\n}\n.open-outer-accordion .side_nav_accordion_outerLabel {\n  color: #1984bc;\n}\n.open-color {\n  color: #1984bc;\n}\n.open-border {\n  border: 1px solid #1984bc;\n}\n.side_nav_inner_value {\n  display: flex;\n}\n.side_nav_inner_value .accArrowIcon {\n  margin-left: 8px;\n}\n.side_nav_accordion__wrapper .accArrowIcon {\n  border-bottom: 2px solid #817c7c;\n  border-left: 2px solid #817c7c;\n  height: 9px;\n  width: 9px;\n  transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  -webkit-transition: all 0.4s;\n  -moz-transition: all 0.4s;\n}\n.side_nav_accordion__wrapper.open-outer-accordion .accArrowIcon-outer,\n.side_nav_accordion__wrapper .open-inner-accordion .accArrowIcon-inner {\n  border-bottom: 2px solid #1984bc;\n  border-left: 2px solid #1984bc;\n  transform: rotate(-225deg);\n  -ms-transform: rotate(-225deg);\n  -webkit-transform: rotate(-225deg);\n  -moz-transform: rotate(-225deg);\n  margin-top: 2px;\n}\n.accordion-disable .accArrowIcon-outer,\n.accordion-disable .accArrowIcon-inner {\n  display: none;\n}\n.accordion-disable .side_nav_accordion__header {\n  cursor: not-allowed;\n  background: rgba(214, 214, 212, 0.3);\n}\n.accordion-disable .side_nav_accordion__header_inner {\n  cursor: not-allowed;\n}\n.accordion-disable .side_nav_accordionClickField,\n.accordion-disable .side_nav_accordionClickField_inner {\n  pointer-events: none;\n}\n.produtType-container {\n  padding: 20px;\n  display: flex;\n  display: -webkit-flex;\n}\n.productTypeField {\n  margin-right: 10px;\n}\n.productTypeValue {\n  font-size: 14px;\n  position: relative;\n  padding-left: 25px;\n  cursor: pointer;\n}\n.productTypeValue:before {\n  content: \"\";\n  position: absolute;\n  height: 18px;\n  width: 18px;\n  border-radius: 50%;\n  border: 1px solid #000;\n  background: #fff;\n  left: 0;\n  top: 0;\n}\n.productActive .productTypeValue:before {\n  border-color: #1984bc;\n}\n.productTypeValue:after {\n  content: \"\";\n  position: absolute;\n  height: 12px;\n  width: 12px;\n  border-radius: 50%;\n  background: #fff;\n  left: 3px;\n  top: 3px;\n}\n.productActive .productTypeValue:after {\n  background: #1984bc;\n}\n.caselisting__table thead tr {\n  border-bottom: 1px solid rgb(231 231 228);\n  border-radius: 10px;\n}\n.caselisting__table th {\n  vertical-align: middle;\n  padding: 15px;\n}\n.caselisting__table {\n  width: 100%;\n  text-align: left;\n  box-shadow: 0px 3px 20px #0000000a;\n  border-radius: 10px;\n  background: #fff;\n  margin-bottom: 20px;\n}\n.caselisting__tableHeading {\n  font-size: 12px;\n  line-height: 1.2;\n  color: #989eac;\n  font-weight: 500;\n}\n.caselisting__table tbody tr:nth-child(odd) {\n  background: #f8f9fa;\n}\n.caselisting__table tbody td {\n  vertical-align: middle;\n  padding: 15px;\n}\n.caselisting__table tbody td span {\n  color: #222222;\n  font-size: 14px;\n  line-height: 1.2;\n  font-weight: 500;\n}\n.caselisting__rowInfo {\n  cursor: pointer;\n}\n.caselisting__loaderWrapper {\n  height: calc(100% - 160px);\n  padding: 0 20px;\n}\n.caselisting__loaderOverlay {\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.caselisting__loaderWrapper .loader > div {\n  border: 8px solid #1984bc;\n  border-color: #1984bc transparent transparent transparent;\n}\n.caselisting__table tbody td span.caseListing__insuredName {\n  color: #1984bc;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
